export enum InfoCardTargetType {
    Film = 1,
    Series = 2,
    Category = 3,
}
